import React, { createContext, useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useDispatch,useSelector} from 'react-redux';
import { store } from './store';

const cookies = new Cookies();
const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
    const SESSION_KEY = 'AccessToken';
    const EXPIRATION_KEY = 'sessionExpiration';
    const [sessionPaused, setSessionPaused] = useState(false);
    const [intervalId, setIntervalId] = useState(null);
    const pauseSession = () => setSessionPaused(true);
    const resumeSession = () => setSessionPaused(false);
    // Helper to get the expiration time
    const getExpirationTime = () => Number(localStorage.getItem('sessionExpiration')) || 0;
    const updateSession = () => {
        if (!isAuthenticated) return;
        // const expirationTime = Date.now() + 20 * 1000; // 10 seconds

         const expirationTime = Date.now() + 15 * 60 * 1000; // 15 Minutes 
        localStorage.setItem(EXPIRATION_KEY, expirationTime.toString());

        // Trigger the storage event manually to notify other tabs
        window.dispatchEvent(new StorageEvent('storage', { key: EXPIRATION_KEY, newValue: expirationTime.toString() }));
    };

    const checkSession = () => {
        const expirationTime = getExpirationTime();
        // console.log('Checking session:', { expirationTime, now: Date.now() });

        if (isAuthenticated && expirationTime > 0 && expirationTime < Date.now()) {
            handleSessionExpired();
        }
    };

    const handleSessionExpired = () => {
        if (!isAuthenticated) return;
    // Set highmark session flag before redirect
    const ssoPortal = store.getState()?.sso?.ssoUserData?.Portal;
    if (ssoPortal === "Highmark") {
        sessionStorage.setItem("highmarkSession", "true");
    } else {
        sessionStorage.removeItem("highmarkSession");
    }
        // Mark session as expired (but don't clear Redux yet)
        localStorage.setItem('sessionExpired', 'true');
        localStorage.setItem(EXPIRATION_KEY, '0');        // Redirect to session-expired page BEFORE clearing Redux state
        window.location.href = '/session-expired';
        // navigate('/session-expired');
        
        setTimeout(() => {
            // Now clear session data after a delay to prevent immediate logout redirection
            dispatch({ type: 'CLEAR_REDUX_STATE' });
            setIsLoggedIn(false);
            // Remove cookies
            cookies.remove(SESSION_KEY, { path: '/' });
            // Notify other tabs about session expiration
            window.dispatchEvent(new StorageEvent('storage', { key: 'sessionExpired', newValue: 'true' }));
        }, 1500); // Increased delay to 1.5 seconds to allow session-expired page to fully load
    };
    
    

    useEffect(() => {
        if (!isAuthenticated) return;
        const handleStorageChange = (event) => {
            // console.log('Storage event triggered:', event);

            // Check session expiration only when the expiration key changes
            if (event.key === EXPIRATION_KEY) {
                const expirationTime = getExpirationTime();

                if (expirationTime === 0) {
                    // If expiration is flagged as 0, treat the session as expired
                    handleSessionExpired();
                } else {
                    // Otherwise, perform a normal session check
                    checkSession();
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [isAuthenticated]);

    useEffect(() => {
       // debugger
        if (!isAuthenticated) return;
        if (intervalId) clearInterval(intervalId);
        if (!sessionPaused) {
            const interval = setInterval(checkSession, 1000); // Check every 1 second
            setIntervalId(interval);
            return () => clearInterval(interval);
        }
    }, [isAuthenticated, sessionPaused]);

    useEffect(() => {
        if (!isAuthenticated) return;
        const activityEvents = ['click', 'keypress', 'mousemove', 'scroll'];
        const handleActivity = () => updateSession();

        activityEvents.forEach((event) => window.addEventListener(event, handleActivity));
        return () => {
            activityEvents.forEach((event) => window.removeEventListener(event, handleActivity));
        };
    }, [isAuthenticated]);

    return (
        <SessionContext.Provider value={{ isLoggedIn, updateSession, pauseSession, resumeSession }}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => {
    return useContext(SessionContext);
};
